import { subtract } from 'modules/math';
import {
  FactFinderFacet,
  FactFinderSuggestions,
} from 'commerce/factFinder/types';

export const parseCategories = async (
  apiResponse: Promise<{ facets: FactFinderFacet[] } | undefined>,
  categoriesMap: any,
) => {
  return apiResponse.then((response) => {
    const categoryNames =
      response?.facets?.find((facet) => facet.type === 'CATEGORY_PATH')
        ?.elements || [];

    const categories: Record<
      string,
      { name: string; url: string; totalHits: number }
    > = categoryNames.reduce((acc, el) => {
      if (categoriesMap?.[el.text]) {
        return {
          ...acc,
          [el.text]: {
            name: el.text,
            url: categoriesMap[el.text],
            totalHits: el.totalHits,
          },
        };
      }

      return acc;
    }, {});

    return Object.values(categories)
      .filter((category) => category.url.split('/').slice(1).length > 1) // skip first level categories
      .sort((a, b) => subtract(b.totalHits, a.totalHits));
  });
};

export const parseKeywords = (
  apiResponse: Promise<FactFinderSuggestions[] | undefined>,
  query: string,
) => {
  return apiResponse.then((keywords) => {
    return {
      correspondingUrl: keywords?.find(
        ({ attributes }) =>
          attributes?.keywords?.toLowerCase() === query.toLowerCase(),
      )?.attributes?.Url,
      keywords: keywords?.filter((a) => a.attributes.Url).slice(0, 10),
    };
  });
};
